import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface DeviceState {
  selectedDeviceId: string;
}

const initialState: DeviceState = {
  selectedDeviceId: '',
};

const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    setSelectedDeviceId: (state, action: PayloadAction<string>) => {
      state.selectedDeviceId = action.payload;
    },
    resetDeviceSelection: (state) => {
      state.selectedDeviceId = '';
    },
  },
});

export const { setSelectedDeviceId, resetDeviceSelection } = deviceSlice.actions;
export default deviceSlice.reducer; 